const KEYS = {

    context: 'current-user-context',
    migrations: 'migrations',
    cookieConsent: 'cookie-consent',
    token: 'token',
    partref: 'partner-ref',
}

export { KEYS }
export default KEYS
